import { core } from '@/core'
import Basic from '@basic'
import { Button } from '@bag'

const util = {
  pullTopButton(opt, tar) {
    const { top } = tar.members
    const option = {
      icon: 'arrow-circle-up',
      shape: 'primary',
      textContent: '返回顶部',
    }
    const button = new Button(option)
    top.append(button.unit)
    return button
  },
  pullToggleButton(opt, tar) {
    const { toggle } = tar.members
    const option = {
      icon: 'times',
      shape: 'info',
      textContent: '关闭',
    }
    const button = new Button(option)
    toggle.append(button.unit)
    return button
  },
  template: {
    quick() {
      return $(`
      <div class="lt-quick">
        <div id="top" class="quick_backtop"></div>
        <div id="links" class="quick_links button-group-v"></div>
        <div id="toggle" class="quick_toggle"></div>
      </div>`)
    },
  },
  updater: {
    pick(value, opt, tar, node) {
      const { toggleButton } = tar
      if (value) {
        tar.unit.addClass('pick-up')
        toggleButton.rotate = true
        setTimeout(() => {
          toggleButton.rotate = false
        }, 625)
      } else {
        tar.unit.addClass('pick-up-ing')
        toggleButton.rotate = true
        setTimeout(() => {
          toggleButton.rotate = false
          tar.unit.removeClass('pick-up pick-up-ing')
        }, 625)
      }
    },
    topShow(value, opt, tar, node) {
      if (value) {
        tar.unit.removeClass('is-top-hidden')
      } else {
        tar.unit.addClass('is-top-hidden')
      }
    },
    anchor(value, opt, tar, node) {
      $(tar.old.anchor).unbind('scroll', tar.scroll)
      $(value).scroll($.proxy(tar.scroll, tar))
    },
    slot(value, opt, tar, node) {
      const { links } = tar.members
      if (Array.isArray(value)) {
        links.empty()
        tar.buttons = {}
        value.map(option => {
          const { name } = option
          option.clickLoad = true
          const button = new Button(option)
          links.append(button.unit)
          tar.buttons[name] = button
        })
      }
    },
    show(value, opt, tar, node) {
      if (value) {
        tar.unit.removeClass('is-hidden')
      } else {
        tar.unit.addClass('is-hidden')
      }
    },
    right(value, opt, tar, node) {
      if (value === null) {
        tar.unit.css({ right: ' ' })
      } else {
        tar.unit.css({ right: value * 1 })
      }
    },
    bottom(value, opt, tar, node) {
      if (value === null) {
        tar.unit.css({ bottom: ' ' })
      } else {
        tar.unit.css({ bottom: value * 1 })
      }
    },
  },
}

export default class Quick extends Basic {
  constructor(opt) {
    super(opt)
    const def = {}
    this.defaults = {
      show: true, // 控件的显示和隐藏
      pick: false, // 功能按钮组的显示隐藏
      topShow: false, // 回到顶部按钮的显示隐藏
      anchor: window, // 滚动锚点
      slot: [], // 按钮组各个按钮属性
      right: null, // 右边距
      bottom: null, // 下边距
    }
    this.events = {
      topClick: 'onTopClick', // 回到顶部按钮 点击事件
      pickUp: 'onPickUp', // 按钮组显示隐藏  伴随的事件
      scroll: 'onScroll', // 锚点内容 滚动事件
    }
    core.proxyApi(this) // 核心属性处理
    core.proxyEvent(this) // 核心事件处理
    this.settings = Object.assign({}, def, this.defaults, opt)
    this.init()
  }

  init() {
    const opt = this.settings
    const template = util.template.quick(opt, this)
    const members = {}
    core.compileSymbol(template[0], members)
    this.members = members
    this.unit = template
    this.topButton = util.pullTopButton(opt, this)
    this.toggleButton = util.pullToggleButton(opt, this)
    core.update(util.updater, opt, this)
    this.bindInput()
  }

  destroy() {
    this.unit.empty().remove()
  }

  bindInput() {
    this.topButton.click($.proxy(this.topClick, this))
    this.toggleButton.click($.proxy(this.pickUp, this))
  }

  onScroll() {
    const top = $(this.anchor).scrollTop()
    if (top > 100) {
      this.topShow = true
    } else {
      this.topShow = false
    }
    if (top <= 0) {
      clearInterval(this.timer)
    }
  }

  onTopClick() {
    clearInterval(this.timer)
    let top = $(this.anchor).scrollTop()
    this.timer = setInterval(() => {
      top = top - 60
      $(this.anchor).scrollTop(top)
    }, 30)
  }

  onPickUp() {
    this.pick = !this.pick
  }

  hideBtn(...res) {
    core.currySomething((objs, name) => {
      const item = objs[name]
      item.show = false
    })(this.buttons)(res)
  }

  showBtn(...res) {
    core.currySomething((objs, name) => {
      const item = objs[name]
      console.log(item)
      item.show = true
    })(this.buttons)(res)
  }
}
